// Formats the given camelCase string to a human readable text, where the first character is capitalized and there is a space before the uppercase characters
export const formatEnumValue = (value: string): string => {
  return value
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};
